import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useTrackingAdapter } from "@av/components/utilities/trackings/useTrackingAdapter";
import { useCanReceiveUserpilotAsAts } from "./useCanReceiveUserpilotAsAts";
import { useCanReceiveUserpilotAsHr } from "./useCanReceiveUserpilotAsHr";
import { useCurrentUser } from "../../services/authentication/user/current-user";
import { useBrowserConfig } from "../../services/config/browser-config";

export function Tracking() {
  const { data } = useBrowserConfig();
  const trackingAdapter = useTrackingAdapter();
  const { data: currentUser } = useCurrentUser();
  const location = useLocation();
  const canReceiveUserpilotAsHr = useCanReceiveUserpilotAsHr();
  const canReceiveUserpilotAsAts = useCanReceiveUserpilotAsAts();
  // Userpilot notifications should only be sent to those with access to Userpilot,
  // which includes HR Admin/Manager and ATS Admin/Recruiter users
  const canReceiveUserpilotMessages = canReceiveUserpilotAsHr || canReceiveUserpilotAsAts;

  useEffect(() => {
    if (data?.userPilotToken && currentUser && canReceiveUserpilotMessages) {
      trackingAdapter.initialize(data.userPilotToken);
      trackingAdapter.onLogin(
        {
          id: currentUser.id,
          name: currentUser.displayName,
        },
        {
          id: currentUser.company.id,
          name: currentUser.company.commonName,
        }
      );
    }
  }, [currentUser, data?.userPilotToken, trackingAdapter, canReceiveUserpilotMessages]);

  useEffect(() => {
    trackingAdapter.onPageChange(location.pathname);
  }, [location, trackingAdapter]);

  return null;
}
